import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiurl: 'https://admin-estrata.inmac.work'
  },
  mutations: {

  },
  actions: {

  }
})
